import { z } from "zod";
import { PublicIdSchema } from "./common";

/**
 * F14 Slice 4: 配送完了証跡画像.
 * Cloudflare R2 に保存され presigned URL (10 分) で配信される。
 */
export const ProofImageTypeSchema = z.enum(["signature", "photo"]);
export type ProofImageType = z.infer<typeof ProofImageTypeSchema>;

export const ProofImage = z.object({
  id: PublicIdSchema,
  image_type: ProofImageTypeSchema,
  image_url: z.string(),
  created_at: z.iso.datetime({ offset: true }),
});
export type ProofImageDto = z.infer<typeof ProofImage>;

export const ListProofImagesOutput = z.object({
  data: z.array(ProofImage),
});
